<template>
    <div>
        <st-divider class="auth-title" :between="3.4">
            <div>스쿨투게더 PC버전에</div>
            <div>로그인해주세요.</div>
        </st-divider>
        <st-divider :between="3">
            <st-input
                v-model="phone"
                :width="37.5"
                placeholder="'-' 를 제외한 휴대폰 번호를 입력하세요."
                @enter="submitHandler"
            />
        </st-divider>
        <st-divider :between="4">
            <st-button :width="27.5" color="primary" :disabled="!phone || loading || visible" @click="submitHandler">
                다음으로
            </st-button>
        </st-divider>
        <div class="auth-waring">
            스쿨투게더 회원가입은 모바일 앱에서만 진행하실 수 있습니다.
        </div>

        <st-modal v-model="visible" title="앗! 스쿨투게더에 처음이신가요?">
            <template v-slot:body>
                <st-divider :between="2.4">
                    <div>스쿨투게더 서비스 회원가입은 모바일 앱에서만 진행하실 수 있습니다.</div>
                    <div>아래의 링크를 통해 스쿨투게더 앱을 설치하시고 회원가입을 진행하신뒤,</div>
                    <div>PC 버전을 사용해주세요.</div>
                </st-divider>
                <st-divider :between="0.6">
                    <st-input
                        v-model="smsPhone"
                        placeholder="문자를 받으실 휴대폰 번호를 입력해주세요."
                        ref="smsPhone"
                        icon="envelope"
                        pattern="number"
                        block
                    />
                </st-divider>
                <st-divider :between="1.6">
                    <div class="auth-waring">* 위 번호로 설치 문자가 발송되오니 확인 후 전송하시지 바랍니다.</div>
                </st-divider>
            </template>

            <template v-slot:footer>
                <st-button color="primary" block :disabled="!smsPhone" @click="smsMessageHandler">
                    설치 문자(SMS) 보내기
                </st-button>
            </template>
        </st-modal>
    </div>
</template>
<script>
import { dataEncoded } from "../../../utils/lib";

export default {
    name: "AuthLogin",
    data: () => ({
        phone: null,
        loading: false,
        smsPhone: null
    }),
    props: {
        status: Number
    },
    computed: {
        visible: {
            get() {
                return this.status === 1;
            },
            set(value) {
                this.smsPhone = null;
                this.$emit("status", value ? 1 : 0);
            }
        }
    },
    methods: {
        // status 가 1 이면 smsPhone 자동 등록
        hook() {
            this.smsPhone = this.phone;

            this.smsFocusHandler();
        },

        smsFocusHandler() {
            setTimeout(() => {
                this.$refs.smsPhone.focus();
            }, 350);
        },

        async submitHandler() {
            if (!this.phone || this.loading) return;

            const phoneNumber = this.phone.toString().replace(/(\W|\D)/g, "");

            if (/(\W|\D)/g.test(this.phone)) {
                this.$alert("error", "번호에 특수문자, 문자, 공백이 포함되어 있으면 안됩니다.");
                this.loading = false;
                return;
            }

            if (phoneNumber.length < 10 || phoneNumber.length > 11) {
                this.$alert("error", "전화번호는 10자리 이상 11자리 이하여야 합니다.");
                this.loading = false;
                return;
            }

            this.loading = true;
            try {
                const data = dataEncoded({ phoneNumber });
                const response = await this.$api.user.checkUser(data);

                this.loading = false;
                this.$emit("check-user", { response, phone: this.phone, hook: this.hook });
            } catch (e) {
                this.loading = false;
                this.$alert("error", e.message);
            }
        },

        async smsMessageHandler() {
            const phoneNumber = this.smsPhone.toString().replace(/(\W|\D)/g, "");

            if (/(\W|\D)/g.test(this.smsPhone)) {
                this.$alert("error", "번호에 특수문자, 문자, 공백이 포함되어 있으면 안됩니다.");
                this.loading = false;
                return;
            }

            if (phoneNumber.length < 10 || phoneNumber.length > 11) {
                this.$alert("error", "전화번호는 10자리 이상 11자리 이하여야 합니다.");
                this.loading = false;
                return;
            }

            try {
                await this.$api.fetch.post("http://sms.school-mom.kr:3000/app_install_message", {
                    phone: phoneNumber
                });

                this.phone = null;
                this.smsPhone = null;

                this.$emit("status", 0);
                this.$alert("success", "문자 발송이 완료되었습니다.");
            } catch (e) {
                this.$alert("error", e.message);
            }
        }
    }
};
</script>
